<template>
  <!-- The Modal -->
  <div
    id="createModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Create Faq"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_en">Question «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Question En"
                        rules="required"
                      >
                        <b-form-input
                          id="question_en"
                          v-model="createdFaq.question"
                          name="question_en"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="question_ar">Question «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Question Ar"
                        rules="required"
                      >
                        <b-form-input
                          id="question_ar"
                          v-model="createdFaq.questionAR"
                          class="arabic-font"
                          name="question_ar"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                          :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="answerEn">Answer «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Answer En"
                        rules="required"
                      >
                        <template>
                          <b-form-textarea
                            id="answerEn"
                            v-model="createdFaq.answer"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="answerAr">Answer «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Answer Ar"
                        rules="required"
                        :dir="'rtl'"
                      >
                        <template>
                          <b-form-textarea
                            id="answerAr"
                            v-model="createdFaq.answerAR"
                            class="arabic-font"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import newsService from '@/services/newsService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import faqsService from "@/services/faqsService";

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      createdFaq:{
        question: '',
        questionAR: '',
        answer: '',
        answerAR: '',
      },
      codeBasic,
      selected: { title: 'Square' },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        console.log(success);
        if (success) {
          faqsService.post(this.createdFaq)
            .then(response => {
              this.$emit('refresh', 'true')

              /* Reset Inputs */
              this.createdFaq = {
                question: '',
                questionAR: '',
                answer: '',
                answerAR: '',
              }
              /* Close Modal */
              $('#createModal').modal('hide')
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'News Is Created Successfully !',
                  },
                })
              }
              /* Hide Spinner */
              this.loading = false
            })
            .catch(
              function (error) {
                $('#createModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: 'Error !',
                  },
                })
                return Promise.reject(error)
              },
            )
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
